enum ValueFilter {
    Yearly = 'yearlyFee',
    Monthly = 'monthlyFee',
    Evaluation = 'evaluationScore',
    Percentage = 'percentage'
}

export default ValueFilter;
